import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import SelectField from "@app/component/input/SelectField";
import { updateIntegrationSyncsViewState } from "@app/store/integrations/actions";
import { getIntegrationViewState } from "@app/store/integrations/selectors";
import { RootState } from "@app/store/rootReducer";
import IntegrationSyncsViewState from "@app/types/viewModel/IntegrationSyncsViewState";

import StatusOption, { getStatusOptionsDisplayName } from "../enum/StatusOption";

import styles from "./StatusFilter.module.scss";

const allStatusOptions = [
  StatusOption.ANY,
  StatusOption.COMPLETED,
  StatusOption.ERRORED,
  StatusOption.COMPLETED_WITH_ERRORS,
];

interface Props {
  updateIntegrationSyncsViewState: typeof updateIntegrationSyncsViewState.request;
  viewState: IntegrationSyncsViewState;
}

const StatusFilter: React.FC<Props> = ({ updateIntegrationSyncsViewState, viewState }) => {
  const intl = useIntl();

  const options = useMemo(
    () =>
      allStatusOptions.map((value) => ({ label: getStatusOptionsDisplayName(intl, value), value })),
    [intl]
  );

  const status = useMemo(
    () => (viewState.statusOption === undefined ? StatusOption.ANY : viewState.statusOption),
    [viewState.statusOption]
  );

  const handleChange = useCallback(
    (option) => {
      updateIntegrationSyncsViewState({ viewState: { statusOption: option } });
    },
    [updateIntegrationSyncsViewState]
  );

  return (
    <SelectField
      className={styles.statusFilter}
      onChange={handleChange}
      options={options}
      value={status}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  viewState: getIntegrationViewState(state),
});

const mapDispatchToProps = {
  updateIntegrationSyncsViewState: updateIntegrationSyncsViewState.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusFilter);
